/* eslint-disable no-unused-vars */
/* eslint-disable camelcase */

const lowerCaseCharacters = 'abcdefghijklmnopqrstuvwxyz';
const upperCaseCharacters = lowerCaseCharacters.toUpperCase();
const digitsCharacters = '0123456789';
const specialsCharacters = '!-_?#$';

export const generatePassword = settings => {
  const {
    digits: { amount: digitsAmount },
    letters: { lowercase: lowerCaseAmount, uppercase: upperCaseAmount, amount: lettersAmount },
    special_characters: { amount: specialsAmount },
    min_length: minLength,
  } = settings;

  // Define allowed character sets based on settings
  let allowedLetters = '';
  if (lowerCaseAmount > 0) allowedLetters += lowerCaseCharacters;
  if (upperCaseAmount > 0) allowedLetters += upperCaseCharacters;

  let allowedCharacters = '';
  if (digitsAmount > 0) allowedCharacters += digitsCharacters;
  if (lowerCaseAmount > 0) allowedCharacters += lowerCaseCharacters;
  if (upperCaseAmount > 0) allowedCharacters += upperCaseCharacters;
  if (specialsAmount > 0) allowedCharacters += specialsCharacters;

  // Generate mandatory characters
  const digits = Array(digitsAmount)
    .fill(0)
    .map(_ => digitsCharacters.charAt(Math.floor(Math.random() * digitsCharacters.length)))
    .join('');

  const lowerCase = Array(lowerCaseAmount)
    .fill(0)
    .map(_ => lowerCaseCharacters.charAt(Math.floor(Math.random() * lowerCaseCharacters.length)))
    .join('');

  const uppercase = Array(upperCaseAmount)
    .fill(0)
    .map(_ => upperCaseCharacters.charAt(Math.floor(Math.random() * upperCaseCharacters.length)))
    .join('');

  const specials = Array(specialsAmount)
    .fill(0)
    .map(_ => specialsCharacters.charAt(Math.floor(Math.random() * specialsCharacters.length)))
    .join('');

  // Ensure minimum letters amount is met with allowed letters
  const requiredLetters = Math.max(0, lettersAmount - lowerCaseAmount - upperCaseAmount);
  const additionalLetters = Array(requiredLetters)
    .fill(0)
    .map(_ => allowedLetters.charAt(Math.floor(Math.random() * allowedLetters.length)))
    .join('');

  // Combine mandatory and additional letters
  const tempResult = `${uppercase}${lowerCase}${additionalLetters}${digits}${specials}`;

  // Fill to minLength with allowed characters
  const additionalSymbolsAmount = Math.max(0, minLength - tempResult.length);
  const additionalSymbols = Array(additionalSymbolsAmount)
    .fill(0)
    .map(_ => allowedCharacters.charAt(Math.floor(Math.random() * allowedCharacters.length)))
    .join('');

  // Combine and shuffle
  const resultArr = `${tempResult}${additionalSymbols}`.split('');
  resultArr.forEach((v, i, arr) => {
    const randomIndex = Math.floor(Math.random() * arr.length);
    [arr[i], arr[randomIndex]] = [arr[randomIndex], arr[i]];
  });

  return resultArr.join('');
};
